export default (key) => {
  const segments = key.split('brand');
  const num = segments[segments.length - 1] * 1;
  switch (key) {
    case 'brand1':
      return { name: 'brand', key: num - 1 };
    default:
      return { name: `comp${num - 1}`, key: num - 1 };
  }
};
